import styled from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  spacing
} from '../../theme';

export const StyledTel = styled.div`
  --PhoneInput-color--focus: ${color('midnight_850')};
  --PhoneInputCountryFlag-borderColor--focus: ${color('active')};
  --PhoneInputCountryFlag-borderWidth: 2px;

  .PhoneInputCountry {
    background-color: ${color('white')};
    padding: 1.25rem;
    border-radius: ${radius('md')} 0 0 ${radius('md')};
    border: 2px solid ${color('midnight_200')};
    border-right: 0;
    height: 3.5rem;
    margin-right: 0;

    &:hover {
      border-color: ${color('midnight_400')};
    }
  }

  .PhoneInputInput {
    width: 100%;
    height: 3.5rem;
    padding: 1.25rem;
    font-family: ${fontFamily('sans')};
    font-size: ${fontSize('sm')};
    font-weight: ${fontWeight('medium')};
    color: ${color('text_default')};
    border-radius: 0 ${radius('md')} ${radius('md')} 0;
    border: 2px solid ${color('midnight_200')};
    transition: 0.3s;

    &:hover {
      border-color: ${color('midnight_400')};
    }

    &:focus {
      outline: 0;
      border-color: ${color('midnight_850')};
      box-shadow: 0 0 0 4px ${color('midnight_150')};
    }
  }

  .PhoneInputCountryIcon {
    --PhoneInputCountryFlag-aspectRatio: 1;

    border: 0;
    box-shadow: unset;
    width: ${spacing('md')};
    height: ${spacing('md')};
    border-radius: ${radius('sm')};
    overflow: hidden;
    color: ${color('text_subtle')};
  }

  .PhoneInputCountryIconImg {
    object-fit: cover;
    filter: grayscale(20%);
  }

  .PhoneInputCountrySelectArrow {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 0;
    border-top: 5px solid ${color('text_default')};
    border-radius: 2px;
    opacity: 1;
    transform: unset;
  }
`;
